import React from "react";
import { Button } from "../ui/button";
import { motion } from "framer-motion";

const Hero = () => {
  return (
    <section className="py-20">
      <div className="container px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.5 }}
          >
            <div className="inline-block bg-green-100 text-green-700 text-sm font-semibold px-4 py-1 rounded-full mb-6">
              20 founding spots · CAD $39/month
            </div>
            <h1 className="text-4xl md:text-5xl font-bold tracking-tight mb-6">
              Serve immigrants and newcomers who need care that <span className="text-primary">truly understands them</span>
            </h1>
            <p className="text-xl text-gray-700 mb-8">
              MindPulse connects culturally-aware therapists with patients from immigrant and marginalized communities. Less admin, more impact. Half the price of Jane.
            </p>
            <div className="flex flex-wrap gap-4">
              <a href="/therapists/sign_up">
                <Button variant="secondary" className="rounded-full text-white px-6 py-4 h-auto text-lg">
                  Claim Your Founding Spot
                </Button>
              </a>
              <a href="#pricing">
                <Button variant="outline" className="rounded-full px-6 py-4 h-auto text-lg">
                  See Pricing
                </Button>
              </a>
            </div>
          </motion.div>
          <motion.div
            initial={{ opacity: 0, x: 20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.5, delay: 0.2 }}
            className="rounded-lg overflow-hidden shadow-xl"
          >
            <img
              src="https://images.pexels.com/photos/5217852/pexels-photo-5217852.jpeg"
              alt="Therapist working with client"
              className="w-full h-auto object-cover"
            />
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
